import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/hooks';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '../../../shared-functions/LocalStorage';
import { passwordValidation } from '../../../shared-functions/Validation';
import authApi from '../../../utils/api/auth';

/**
 * Login page function component
 */
function NewPasswordChange() {
  const { t, i18n } = useTranslation('loginV2');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const passwordResetDetails = getLocalStorageItem('passwordReset');
  const [credentials, setCredentials] = useState<{
    password: string;
    rePassword: string;
  }>({
    rePassword: '',
    password: '',
  });
  const [submitOpen, setSubmitOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  /**
   * Input field change function
   * @param name
   * @param changeValue
   */
  const handleCredentialChange = (name: string, changeValue: string | number) => {
    setCredentials({
      ...credentials,
      [name]: changeValue,
    });
  };

  /**
   * handle submit function
   */
  const submitFunction = () => {
    setSubmitOpen(true);
    if (
      passwordValidation(credentials.password) &&
      credentials.password === credentials.rePassword
    ) {
      setDisabled(true);
      const request = {
        countryCode: passwordResetDetails.countryCode,
        emailOrPhoneNumber: passwordResetDetails.emailOrPhoneNumber,
        otp: passwordResetDetails.otp,
        newPassword: credentials.password,
      };
      authApi
        .createPassword(request)
        .then(() => {
          removeLocalStorageItem('passwordReset');
          setDisabled(false);

          // navigate('../ev-admin/dashboard');
          navigate('../ev-admin/account');
        })
        .catch((error) => {
          setDisabled(false);
          dispatch(
            setNotificationMessage({
              message: error?.response?.data?.message,
              status: true,
              type: 'error',
              code: error?.response?.data?.code,
            }),
          );
        });
    }
  };
  return (
    <div className="login-v2-wrapper" dir={i18n.dir()}>
      <CustomInput
        inputLabel={t('createNewPassword')}
        type="password"
        placeholder={t('enterPassword')}
        name="password"
        value={credentials.password}
        onChangeValue={handleCredentialChange}
        error={submitOpen && !passwordValidation(credentials.password)}
        errorMessage={t('passwordRule')}
      />
      <CustomInput
        inputLabel={t('confirmPassword')}
        type="password"
        placeholder={t('enterPassword')}
        name="rePassword"
        value={credentials.rePassword}
        onChangeValue={handleCredentialChange}
        error={submitOpen && credentials.rePassword !== credentials.password}
        errorMessage={t('confirmPasswordError')}
      />
      <MyButton
        label={t('submit')}
        buttonType="submit"
        onClickFunc={submitFunction}
        disabled={disabled}
      />
    </div>
  );
}

export default NewPasswordChange;
